(function(){
  // --- Setup modal ---
  const modal = document.createElement('div');
  modal.className = 'lg-modal';
  modal.innerHTML = `
  <div class="masked-svg"></div>
    <div class="lg-frame" role="dialog" aria-modal="true" aria-label="Image viewer">
      <img class="lg-img" alt="">
      
    </div>
      <div class="lg-close" aria-label="Close">&times;</div>
      <div class="lg-prev" aria-label="Previous">&#x276E;</div>
      <div class="lg-next" aria-label="Next">&#x276F;</div><div class="masked-svg"></div>`;
  document.addEventListener('DOMContentLoaded', () => document.body.appendChild(modal));

  const img  = () => modal.querySelector('.lg-img');
  const btnC = () => modal.querySelector('.lg-close');
  const btnP = () => modal.querySelector('.lg-prev');
  const btnN = () => modal.querySelector('.lg-next');

  let items = [];
  let pos = 0;

  function pickSrc(el){ return el.dataset.full || el.src; }

  function openAt(container, index){
    items = Array.from(container.querySelectorAll('img'));
    pos = index;
    img().src = pickSrc(items[pos]);
    modal.classList.add('open');
    [pos-1, pos+1].forEach(i => { if(items[i]) new Image().src = pickSrc(items[i]); });
  }

  function close(){ modal.classList.remove('open'); img().src=''; }
  function next(){ openAt(items[0]?.closest('.lg-grid'), (pos+1)%items.length); }
  function prev(){ openAt(items[0]?.closest('.lg-grid'), (pos-1+items.length)%items.length); }

  // --- Click handling ---
  document.addEventListener('click', e => {
    const thumb = e.target.closest('.lg-grid .lg-item img');
    if (!thumb) return;
    e.preventDefault();
    const grid = thumb.closest('.lg-grid');
    const list = Array.from(grid.querySelectorAll('.lg-item img'));
    openAt(grid, list.indexOf(thumb));
  });

  modal.addEventListener('click', e => { if (e.target === modal) close(); });
  document.addEventListener('click', e => {
    if (e.target === btnC()) close();
    else if (e.target === btnN()) { e.stopPropagation(); next(); }
    else if (e.target === btnP()) { e.stopPropagation(); prev(); }
  });

  document.addEventListener('keydown', e => {
    if (!modal.classList.contains('open')) return;
    if (e.key === 'Escape') close();
    else if (e.key === 'ArrowRight') next();
    else if (e.key === 'ArrowLeft') prev();
  });

  // --- Swipe to navigate (mobile / touch) ---
    let startX = 0, startY = 0, dragging = false, activeAxis = null; // 'x' or 'y'
  let width = 0;

  const getPoint = e => (e.touches && e.touches[0]) || (e.changedTouches && e.changedTouches[0]) || e;

  // Create a secondary image for sliding in the neighbor
  let ghost = null;
  function ensureGhost() {
    if (!ghost) {
      ghost = document.createElement('img');
      ghost.className = 'lg-img lg-ghost';
      ghost.alt = '';
      ghost.style.position = 'absolute';
      ghost.style.top = '0';
      ghost.style.left = '0';
      ghost.style.maxWidth = '100%';
      ghost.style.maxHeight = '92vh';
      ghost.style.borderRadius = '8px';
      ghost.style.boxShadow = '0 10px 40px rgba(0,0,0,.35)';
      ghost.style.willChange = 'transform';
      img().parentNode.appendChild(ghost);
      ghost.style.display = 'none';
    }
    return ghost;
  }

  function setTransform(x, y=0, target=img()) {
    target.style.transform = `translate3d(${x}px, ${y}px, 0)`;
  }
  function setTransition(on, target=img()) {
    target.style.transition = on ? 'transform 220ms ease' : 'none';
  }

  function neighborSrc(dir) { // dir: +1 next, -1 prev
    const grid = items[0]?.closest('.lg-grid');
    if (!grid) return null;
    const list = Array.from(grid.querySelectorAll('.lg-item img'));
    const idx = (pos + (dir > 0 ? 1 : -1) + list.length) % list.length;
    return list[idx] ? (list[idx].dataset.full || list[idx].src) : null;
  }

  function onStart(e) {
    if (!modal.classList.contains('open')) return;
    const p = getPoint(e);
    width = img().getBoundingClientRect().width || window.innerWidth;
    startX = p.clientX;
    startY = p.clientY;
    dragging = true;
    activeAxis = null;
    setTransition(false, img());
    ensureGhost(); setTransition(false, ghost);
    ghost.style.display = 'none';
  }

  function onMove(e) {
    if (!dragging) return;
    const p = getPoint(e);
    const dx = p.clientX - startX;
    const dy = p.clientY - startY;

    // Decide axis on first significant move
    if (!activeAxis) {
      if (Math.abs(dx) > 10 || Math.abs(dy) > 10) {
        activeAxis = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      } else {
        return;
      }
    }

    if (activeAxis === 'x') {
      e.preventDefault(); // keep control
      // Position current image following finger
      setTransform(dx, 0, img());

      // Prepare ghost image on the side you’re pulling toward
      const dir = dx < 0 ? +1 : -1;
      const src = neighborSrc(dir);
      if (src) {
        ghost.src = src;
        ghost.style.display = '';
        // Ghost starts off-canvas
        setTransform(dx < 0 ? width + dx : -width + dx, 0, ghost);
      }
    } else {
      // vertical drag – optional: pull-down to close feel
      setTransform(0, dy * 0.08, img());
    }
  }

  function onEnd(e) {
    if (!dragging) return;
    dragging = false;

    const p  = getPoint(e);
    const dx = p.clientX - startX;
    const dy = p.clientY - startY;

    const SWIPE_X = Math.max(60, width * 0.18); // threshold as fraction of width
    const SWIPE_DOWN = 120;

    // Animate back by default
    setTransition(true, img());
    ensureGhost(); setTransition(true, ghost);

    if (activeAxis === 'x' && Math.abs(dx) > SWIPE_X) {
      // Commit to next/prev
      const dir = dx < 0 ? +1 : -1;

      // Slide current out, ghost in
      setTransform(dir < 0 ? width : -width, 0, img());
      setTransform(0, 0, ghost);

      // After animation: actually change the image, hide ghost, reset transforms
      setTimeout(() => {
        setTransition(false, img());
        setTransition(false, ghost);
        // trigger actual navigation (updates items/pos and sets src)
        if (dir > 0) next(); else prev();
        // reset transforms
        setTransform(0, 0, img());
        ghost.style.display = 'none';
        setTransform(0, 0, ghost);
      }, 220);

    } else if (activeAxis !== 'x' && dy > SWIPE_DOWN) {
      // vertical close
      close();
      // reset
      setTimeout(() => { setTransition(false, img()); setTransform(0,0,img()); }, 0);
    } else {
      // Snap back
      setTransform(0, 0, img());
      setTransform(0, 0, ghost);
      setTimeout(() => { setTransition(false, img()); setTransition(false, ghost); ghost.style.display = 'none'; }, 220);
    }

    activeAxis = null;
  }

  modal.addEventListener('touchstart', onStart, { passive: true });
  modal.addEventListener('touchmove',  onMove,  { passive: false });
  modal.addEventListener('touchend',   onEnd,   { passive: true });

  // Trackpad / mouse drag (optional)
  modal.addEventListener('pointerdown', onStart);
  modal.addEventListener('pointermove', onMove);
  modal.addEventListener('pointerup',   onEnd);
})();
